import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
} from '@angular/core';

@Component({
  selector: 'hx-count-up',
  standalone: true,
  template: `{{ display }}{{ suffix }}`,
  host: {
    class: 'stat-number',
  },
})
export class CountUpComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) target = 0;
  @Input() suffix = '';
  @Input() durationMs = 1400;

  display = '0';

  private observer?: IntersectionObserver;
  private animationId = 0;
  private started = false;

  constructor(
    private el: ElementRef<HTMLElement>,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    if (!('IntersectionObserver' in window)) {
      this.display = this.target.toString();
      this.cdr.detectChanges();
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting || this.started) {
          return;
        }

        this.started = true;
        this.observer?.disconnect();
        this.animate();
      },
      {
        threshold: 0.35,
      }
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    cancelAnimationFrame(this.animationId);
  }

  private animate(): void {
    const start = performance.now();

    const frame = (time: number) => {
      const progress = Math.min((time - start) / this.durationMs, 1);

      // Ease Out Cubic
      const eased = 1 - Math.pow(1 - progress, 3);

      this.display = Math.round(this.target * eased).toString();

      this.cdr.detectChanges();

      if (progress < 1) {
        this.animationId = requestAnimationFrame(frame);
      }
    };

    this.animationId = requestAnimationFrame(frame);
  }
}